/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileFormatTxtIcon16Light = forwardRef('FileFormatTxtIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.5 2A1.5 1.5 0 0 0 4 3.5V4H3v-.5A2.5 2.5 0 0 1 5.5 1h4.015a1.5 1.5 0 0 1 1.06.44l1.986 1.984a1.5 1.5 0 0 1 .358.576h-1.197L9.87 2.146A.5.5 0 0 0 9.515 2H5.5Z" }),
        React.createElement("path", { d: "M3 11h1v.5A1.5 1.5 0 0 0 5.5 13h5a1.5 1.5 0 0 0 1.5-1.5V11h1v.5a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 3 11.5V11Z" }),
        React.createElement("path", { d: "M5.473 5.03H1.497v.84h1.498V10h.98V5.87h1.498v-.84Z" }),
        React.createElement("path", { d: "M10.388 10 8.575 7.368l1.624-2.338H9.107L8 6.675 6.888 5.03H5.782l1.617 2.331L5.593 10h1.085l1.309-1.925L9.289 10h1.099Z" }),
        React.createElement("path", { d: "M14.483 5.03h-3.976v.84h1.498V10h.98V5.87h1.498v-.84Z" })));
});
